import React, { useState, useEffect, useRef } from 'react';
import Header from '../../components/Header';
import { useHistory, useParams } from "react-router-dom";
import './index.css';
import { parse, intervalToDuration, isValid } from 'date-fns';
import { format } from 'date-fns-tz';
import api from '../../services/api_irrigacao';
import { mask, unMask } from 'remask';
import moment from 'moment';
import apiadi from '../../services/api_adiantamento';
import { fi } from 'date-fns/locale';
import Swal from 'sweetalert2';


export default function Importacao() {
    const [capa, setCapa] = useState({
        frota: {},
        pessoa1: {},
        pessoa2: {},
        pessoa3: {},
        tipo: 0,
    });
    const [tipoAplicacao, setTipoAplicacao] = useState({
        items: [
            { id: 1, text: "CONVENCIONAL" },
            { id: 2, text: "HIDRO-ROLL" },
            { id: 3, text: "LOCALIZADA" },
        ],
        selectItem: 1
    });
    const [tipoIrrigacao, setTipoIrrigacao] = useState({
        items: [
            { id: 1, text: "AGUA" },
            { id: 2, text: "VINHAÇA" },
        ],
        selectItem: 1
    });
    const [dados, setDados] = useState([]);
    const [lcto, setLcto] = useState({
        propriedade: {},
        talhao: {},
    });
    const [insumos, setInsumos] = useState([]);

    const [data, setData] = useState('');
    const [os, setOs] = useState('');
    const [frota, setFrota] = useState('');
    const [imp, setImp] = useState('');
    const [fazenda, setFazenda] = useState({ id: '' });
    const [codFazenda, setCodFazenda] = useState('');
    const [talhao, setTalhao] = useState({});
    const [codTalhao, setCodTalhao] = useState('');
    const [inicio, setInicio] = useState('');
    const [termino, setTermino] = useState('');
    const [area, setArea] = useState('');
    const [lamina, setLamina] = useState('');
    const [volume, setVolume] = useState('');
    const [metragem, setMetragem] = useState('');
    const [espacamento, setEspacamento] = useState('');
    const [pessoa, setPessoa] = useState({});
    const [matricula, setMatricula] = useState('');
    const [operacao, setOperacao] = useState({});
    const [codOperacao, setCodOperacao] = useState('');
    const [etapa, setEtapa] = useState({});
    const [codEtapa, setCodEtapa] = useState('');
    const [qtdAplicada, setQtdAplicada] = useState('');
    const [novoEtapa, setNovoEtapa] = useState({});
    const [novoCodEtapa, setNovoCodEtapa] = useState('');
    const [novoOperacao, setNovoOperacao] = useState({});
    const [novoCodOperacao, setNovoCodOperacao] = useState('');
    const [novoProduto, setNovoProduto] = useState({});
    const [novoCodProduto, setNovoCodProduto] = useState('');
    const [novoReq, setNovoReq] = useState('');
    const [novoRec, setNovoRec] = useState('');
    const [novoQtd, setNovoQtd] = useState('');
    const [novoQtdAplic, setNovoQtdAplic] = useState('');
    const [horimIni, setHorimIni] = useState('');
    const [horimFim, setHorimFim] = useState('');
    const [salvando, setSalvando] = useState(false);

    //controle de elementos
    const frotaRef = useRef(null);
    const impRef = useRef(null);
    const osRef = useRef(null);
    const etapaRef = useRef(null);
    const operacaoRef = useRef(null);
    const fazendaRef = useRef(null);
    const talhaoRef = useRef(null);
    const inicioRef = useRef(null);
    const terminoRef = useRef(null);
    const areaRef = useRef(null);
    const laminaRef = useRef(null);
    const volumeRef = useRef(null);
    const metragemRef = useRef(null);
    const produtoRef = useRef(null);
    const reqRef = useRef(null);
    const recRef = useRef(null);
    const qtdRef = useRef(null);
    const aplicRef = useRef(null);
    const dataRef = useRef(null);
    const espacamentoRef = useRef(null);
    const qtdAplicRef = useRef(null);
    const matRef = useRef(null);
    const etapaInsumoRef = useRef(null);
    const operacaoInsumoRef = useRef(null);
    const tipoIrrigRef = useRef(null);
    const tipoAplicRef = useRef(null);
    const novoEtapaInsumoRef = useRef(null);
    const novoProdutoRef = useRef(null);
    const novoOperacaoInsumoRef = useRef(null);
    const novoReqRef = useRef(null);
    const novoRecRef = useRef(null);
    const novoQtdRef = useRef(null);
    const horimIniRef = useRef(null);
    const horimFimRef = useRef(null);
    const [modalPartesOpen, setModalPartesOpen] = useState(false);
    const [time, setTime] = useState(false);
    const [importador, setImportador] = useState({});

    function handleSelecTipoAplicacao(value) {
        const tipos = Object.assign([], tipoAplicacao);
        tipos.selectItem = value;
        setTipoAplicacao(tipos);
    }

    let history = useHistory();

    let params = useParams();

    function pegaDadosCapa(capa) {
        setData(moment(capa.dt_irrigacao).utc().format('DD/MM/YYYY'))
        setOs(capa.num_os);
        setFrota(capa.frota.cod_frota);
        setImp(capa.implemento.cod_frota);
        setHorimIni(capa.horimetro_ini ? capa.horimetro_ini.toString() : '');
        setHorimFim(capa.horimetro_fim ? capa.horimetro_fim.toString() : '');
    }
    function handleSelecTipoIrrigacao(value) {
        const tipo = Object.assign([], tipoIrrigacao);
        tipo.selectItem = value;
        setTipoIrrigacao(tipo);
    }

    // useEffect(() => {
    //     if (modalPartesOpen) {
    //         apiadi.get(`/importadores/importador?descricao=PARTES`).then(function (response) {
    //             if (response.data) {
    //                 setImportador(response.data)
    //                 if (response.data.importadores_status[0].status === 5) {
    //                     setModalPartesOpen(false);
    //                     return;
    //                 }
    //                 setTimeout(function () {
    //                     setTime(time + 1);
    //                 }, 3000);
    //             }
    //         }).catch(function (error) {
    //             // handle error
    //             console.log(error);
    //         }).then(function () {
    //             // always executed
    //         });
    //     }
    // }, [time, modalPartesOpen]);

    useEffect(() => {
        if (params.id) {
            api.get(`/capa/id/${params.id}`).then(function (response) {
                if (response.data) {
                    console.log('tem response', response.data)
                    setCapa(response.data);
                    handleSelecTipoAplicacao(response.data.tipo_aplicacao.id);
                    handleSelecTipoIrrigacao(response.data.tipo_irrigacao.id);
                    pegaDadosCapa(response.data);
                    api.get(`/dados/capa/id/${params.id}`).then(function (response) {
                        if (response.data) {
                            setDados(response.data);
                        }
                    }).catch(function (error) {
                        alert(error);
                        // handle error
                        console.log(error);
                    }).then(function () {
                        // always executed
                    });
                } else {
                    Swal.fire('Atenção, capa não encontrada nesta empresa!');
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
            
        }
    }, [params.id]);

    function onDeleteInsumo(index, id) {
        api.delete(`/insumos/id/${id}`).then(function (response) {
            if (response.data) {
                const insumosdelete = Object.assign([], insumos);
                insumosdelete.splice(index, 1);
                setInsumos(insumosdelete);

                // const lctodelete = Object.assign([], lcto);
                // lctodelete.insumos.splice(index, 1);
                // setLcto(lctodelete);
            }
        }).catch(function (error) {
            alert(error);
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });

    }

    function pegaDadosLcto(lcto) {
        setMatricula(lcto.pessoa.matricula);
        setCodOperacao(lcto.operacao.cod_operacao);
        setCodEtapa(lcto.etapa.cod_etapa);

        setCodFazenda(lcto.propriedade ? lcto.propriedade.codprop : '');
        setFazenda(lcto.propriedade ? lcto.propriedade : null);

        setCodTalhao((lcto.talhao ? lcto.talhao.cod_talhao : ''));
        setTalhao(lcto.talhao ? lcto.talhao : null);
        setInicio(lcto.hr_ini ? moment(lcto.hr_ini).utc().format('HH:mm') : '');
        setTermino(lcto.hr_fim ? moment(lcto.hr_fim).utc().format('HH:mm') : '');
        handleMaskArea(lcto.area ? lcto.area.toString().replace('.', ',') : '');
        handleMaskLamina(lcto.lamina ? lcto.lamina.toString().replace('.', ',') : '');
        handleMaskVolume(lcto.volume ? lcto.volume.toString().replace('.', ',') : '');
        handleMaskMetragem(lcto.mt_mangueira ? lcto.mt_mangueira.toString().replace('.', ',') : '');
        handleMaskEspacamento(lcto.espacamento ? lcto.espacamento.toString().replace('.', ',') : '');
        setQtdAplicada(lcto.qtd_aplicada ? lcto.qtd_aplicada.toString().replace('.', ',') : '');
    }

    function clickdados(e) {
        var selectedlcto = Object.assign([], dados.find(itemlcto => itemlcto.id === parseInt(e.target.id)));
        setLcto(selectedlcto);
        setInsumos(selectedlcto.insumos);
        pegaDadosLcto(selectedlcto);
        setPessoa(selectedlcto.pessoa);
        setOperacao(selectedlcto.operacao);
        setEtapa(selectedlcto.etapa);
    }

    function rowLctos(lcto) {

        return (
            <tr className="trdados" onClick={clickdados}>
                <td id={lcto.id}>{lcto.pessoa ? lcto.pessoa.matricula : ''}</td>
                <td id={lcto.id}>{lcto.pessoa ? lcto.pessoa.nome : ''}</td>
                <td id={lcto.id}>{lcto.operacao ? lcto.operacao.cod_operacao : ''}</td>
                <td id={lcto.id}>{lcto.operacao ? lcto.operacao.descricao : ''}</td>
                <td id={lcto.id}>{lcto.etapa ? lcto.etapa.cod_etapa : ''}</td>
                <td id={lcto.id}>{lcto.etapa ? lcto.etapa.descricao : ''}</td>
                <td id={lcto.id}>{lcto.propriedade ? lcto.propriedade.codprop : ''}</td>
                <td id={lcto.id}>{lcto.propriedade ? lcto.propriedade.descprop : ''}</td>
                <td id={lcto.id}>{lcto.talhao ? lcto.talhao.cod_talhao : ''}</td>
                <td id={lcto.id}>{moment(lcto.hr_ini).utc().format('DD/MM/YYYY HH:mm')}</td>
                <td id={lcto.id}>{moment(lcto.hr_fim).utc().format('DD/MM/YYYY HH:mm')}</td>
                <td id={lcto.id}>{lcto.espacamento}</td>
                <td id={lcto.id}>{lcto.mt_mangueira}</td>
                <td id={lcto.id}>{lcto.lamina}</td>
                <td id={lcto.id}>{lcto.area}</td>
                <td id={lcto.id}>{lcto.volume}</td>
                <td id={lcto.id}>{lcto.qtd_aplicada}</td>
            </tr>
        )
    }

    function renderButtons(index, id) {
        return (
            <div className="">
                <input id={id} type="submit" value="-" className="btn btn-danger btn-lg del" onClick={(e) => onDeleteInsumo(index, id)} />
            </div>
        )
    }

    function renderInsumo(insumo, index) {
        return (
            <div className="insumo">
                <div className="column-insumos">
                    <div className="column-num">
                        <input
                            id={`operacao${insumo.id}`}
                            ref={operacaoInsumoRef}
                            onKeyDown={(e) => handledown(e, produtoRef)}
                            className="form-control edit"
                            type="text"
                            value={(insumo.operacao ? insumo.operacao.cod_operacao : '')}
                        />
                    </div>
                    <div className="column-button">
                        <button type="submit" className="btn btn-info btn-sm search" onClick={onclick}><span className="lnr lnr-magnifier"></span></button>
                    </div>
                    <div className="column-descricao">
                        <p className="descprod">{(insumo.operacao ? insumo.operacao.descricao : '')}</p>
                    </div>
                </div>
                <div className="column-insumos">
                    <div className="column-num">
                        <input
                            id={`etapa${insumo.id}`}
                            ref={etapaInsumoRef}
                            onKeyDown={(e) => handledown(e, operacaoInsumoRef)}
                            value={(insumo.etapa ? insumo.etapa.cod_etapa : '')}
                            className="form-control edit"
                            type="text" />
                    </div>
                    <div className="column-button">
                        <button type="submit" className="btn btn-info btn-sm search" onClick={onclick}><span className="lnr lnr-magnifier"></span></button>
                    </div>
                    <div className="column-descricao">
                        <p className="descprod">{(insumo.etapa ? insumo.etapa.descricao : '')}</p>
                    </div>
                </div>
                <div className="column-insumos">
                    <div className="column-num prim">
                        <input
                            type="text"
                            ref={produtoRef}
                            onKeyDown={(e) => handledown(e, reqRef)}
                            id={`produto${insumo.id}`}
                            className="form-control edit"
                            value={(insumo.produto ? insumo.produto.cod_produto : '')}
                        />
                    </div>
                    <div className="column-button">
                        <button type="submit" className="btn btn-info btn-sm search" onClick={onclick}><span className="lnr lnr-magnifier"></span></button>
                    </div>
                    <div className="column-descricao">
                        <p className="descprod">{(insumo.produto ? insumo.produto.descricao : '')}</p>
                    </div>
                </div>
                <div className="column-qtd">
                    <input
                        ref={reqRef}
                        onKeyDown={(e) => handledown(e, recRef)}
                        type="text"
                        id={`req${insumo.id}`}
                        value={insumo.req}
                        className="form-control edit"
                    />
                </div>
                <div className="column-qtd">
                    <input
                        ref={recRef}
                        onKeyDown={(e) => handledown(e, qtdRef)}
                        type="text"
                        id={`qtdrec${insumo.id}`}
                        value={insumo.qtd_recomendada}
                        className="form-control edit"
                    />
                </div>
                <div className="column-qtd">
                    <input
                        ref={qtdRef}
                        onKeyDown={(e) => handledown(e, aplicRef)}
                        type="text"
                        id={`qtd${insumo.id}`}
                        value={insumo.qtd_produto}
                        className="form-control edit"
                    />
                </div>
                <div className="column-qtd">
                    <input
                        ref={aplicRef}
                        onKeyDown={(e) => handledown(e, produtoRef)}
                        type="text"
                        id={`qtdaplic${insumo.id}`}
                        value={insumo.qtd_aplicada}
                        className="form-control edit"
                    />
                </div>
                {renderButtons(index, insumo.id)}
            </div>
        )
    }

    function handleBuscaNovaOperacao(e) {
        if (e.key === "Enter") {
            api.get(`/operacao/cod_operacao/${e.target.value}/tipo_aplicacao/${tipoAplicacao.selectItem}/tipo_irrigacao/${tipoIrrigacao.selectItem}`)
                .then(function (response) {
                    if (response.data) {
                        if (!response.data.erro) {
                            setNovoOperacao(response.data);

                        } else {
                            setOperacao({});
                            alert(response.data.erro);
                        }
                    }
                }).catch(function (error) {
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });
            handledown(e, novoEtapaInsumoRef)
        }
    }

    function handleSetNovaOperacao(e) {
        // var operacaoedit = Object.assign(novoOperacao);
        // operacaoedit.cod_operacao = e.target.value;
        // setNovoOperacao(operacaoedit);
        setNovoCodOperacao(e.target.value);
    }

    function handleBuscaNovaEtapa(e) {
        if (e.key === "Enter") {
            api.get(`/etapa/cod_etapa/${e.target.value}`)
                .then(function (response) {
                    if (response.data) {
                        setNovoEtapa(response.data);
                    }
                }).catch(function (error) {
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });
            handledown(e, novoProdutoRef)
        }
    }

    function handleSetNovaEtapa(e) {
        // var etapaedit = Object.assign(novoEtapa);
        // etapaedit.cod_etapa = e.target.value;
        // setNovoEtapa(etapaedit);
        setNovoCodEtapa(e.target.value);
    }

    function handleBuscaNovoProduto(e) {
        if (e.key === "Enter") {
            api.get(`/produtos/cod_produto/${e.target.value}`)
                .then(function (response) {
                    if (response.data) {
                        setNovoProduto(response.data);
                    }
                }).catch(function (error) {
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });
            handledown(e, novoReqRef)
        }
    }

    function handleSetNovoProduto(e) {
        // var produtoEdit = Object.assign(novoProduto);
        // produtoEdit.cod_produto = e.target.value;
        // setNovoProduto(produtoEdit);
        setNovoCodProduto(e.target.value);
    }

    function handleSalvarNovoinsumo(e) {
        if (e.key === "Enter") {
            var insumo = {
                ope_dados_id: lcto.id,
                produtos_id: novoProduto.id,
                qtd_recomendada: parseFloat(novoRec.replace(/[^0-9,]*/g, '').replace(',', '.')),
                qtd_produto: parseFloat(novoQtd.replace(/[^0-9,]*/g, '').replace(',', '.')),
                cod_req: parseFloat(novoReq.replace(/[^0-9,]*/g, '').replace(',', '.')),
                area: parseFloat(lcto.area),
                ope_operacoes_id: novoOperacao.id,
                ope_etapas_id: novoEtapa.id,
            };
            api.post(`/insumos`, insumo).then(function (response) {
                if (response.data) {
                    if (response.data.erro) {
                        alert(response.data.erro);
                    } else {
                        var novoinsumo = Object.assign(insumos);
                        novoinsumo.push(response.data);
                        setInsumos(novoinsumo);
                        setNovoProduto({});
                        setNovoCodProduto('');
                        setNovoEtapa({});
                        setNovoCodEtapa('');
                        setNovoOperacao({});
                        setNovoCodOperacao('');
                        setNovoReq('');
                        setNovoRec('');
                        setNovoQtd('');
                        setNovoQtdAplic('');
                    }
                }
            }).catch(function (error) {
                // handle error
                // setMessageSalvar('OCORREU UM ERRO AO SALVAR, VERIFIQUE OS DADOS DIGITADOS')
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
            handledown(e, novoOperacaoInsumoRef);
        }
    }

    function renderNewInsumo() {
        return (
            <div className="insumo">
                <div className="column-insumos">
                    <div className="column-num">
                        <input
                            id="operacao"
                            ref={novoOperacaoInsumoRef}
                            onKeyDown={(e) => handleBuscaNovaOperacao(e)}
                            className="form-control edit"
                            type="text"
                            value={novoCodOperacao}
                            onChange={(e) => handleSetNovaOperacao(e)}
                        />
                    </div>
                    <div className="column-button">
                        <button
                            type="submit"
                            className="btn btn-info btn-sm search"
                            onClick={onclick}
                        >
                            <span className="lnr lnr-magnifier"></span>
                        </button>
                    </div>
                    <div className="column-descricao">
                        <p className="descprod">{novoOperacao ? novoOperacao.descricao : ''}</p>
                    </div>
                </div>
                <div className="column-insumos">
                    <div className="column-num">
                        <input
                            id="etapa"
                            ref={novoEtapaInsumoRef}
                            className="form-control edit"
                            type="text"
                            value={novoCodEtapa}
                            onChange={(e) => handleSetNovaEtapa(e)}
                            onKeyDown={(e) => handleBuscaNovaEtapa(e)}
                        />
                    </div>
                    <div className="column-button">
                        <button type="submit" className="btn btn-info btn-sm search" onClick={onclick}><span className="lnr lnr-magnifier"></span></button>
                    </div>
                    <div className="column-descricao">
                        <p className="descprod">{novoEtapa ? novoEtapa.descricao : ''}</p>
                    </div>
                </div>
                <div className="column-insumos">
                    <div className="column-num">
                        <input
                            type="text"
                            ref={novoProdutoRef}
                            id="produto"
                            className="form-control edit"
                            value={novoCodProduto}
                            onChange={(e) => handleSetNovoProduto(e)}
                            onKeyDown={(e) => handleBuscaNovoProduto(e)}
                        />
                    </div>
                    <div className="column-button">
                        <button type="submit" className="btn btn-info btn-sm search" onClick={onclick}><span className="lnr lnr-magnifier"></span></button>
                    </div>
                    <div className="column-descricao">
                        <p className="descprod">{novoProduto ? novoProduto.descricao : ''}</p>
                    </div>
                </div>
                <div className="column-qtd">
                    <input
                        ref={novoReqRef}
                        onKeyDown={(e) => handledown(e, novoRecRef)}
                        type="text"
                        id="qtdreq"
                        value={novoReq}
                        onChange={(e) => setNovoReq(e.target.value)}
                        className="form-control edit"
                    />
                </div>
                <div className="column-qtd">
                    <input
                        ref={novoRecRef}
                        onKeyDown={(e) => handledown(e, novoQtdRef)}
                        type="text"
                        id="qtdrec"
                        value={novoRec}
                        onChange={(e) => setNovoRec(e.target.value)}
                        className="form-control edit"
                    />
                </div>
                <div className="column-qtd">
                    <input
                        ref={novoQtdRef}
                        onKeyDown={(e) => handleSalvarNovoinsumo(e)}
                        type="text"
                        id="qtd"
                        value={novoQtd}
                        onChange={(e) => setNovoQtd(e.target.value)}
                        className="form-control edit"
                    />
                </div>
                <div className="column-qtd">
                    <input
                        onKeyDown={(e) => handledown(e, novoOperacaoInsumoRef)}
                        type="text"
                        id="qtdaplic"
                        value={novoQtdAplic}
                        className="form-control edit"
                    />
                </div>
            </div>
        )
    }

    function renderInsumos() {
        return (
            <>
                <b>INSUMOS:</b>
                <hr></hr>
                <div className="form modal-insumos">
                    <div className="column-insumos">
                        <div className="column-num">
                            <label>Operação:</label>
                        </div>
                    </div>
                    <div className="column-insumos">
                        <div className="column-num">
                            <label>Etapa:</label>
                        </div>
                    </div>
                    <div className="column-insumos">
                        <div className="column-num prim">
                            <label>Produto:</label>
                        </div>
                    </div>
                    <div className="column-qtd">
                        <label>nº. Req.:</label>
                    </div>
                    <div className="column-qtd">
                        <label>Qtd. Rec.:</label>
                    </div>
                    <div className="column-qtd">
                        <label>Qtd. Prod.:</label>
                    </div>
                    <div className="column-qtd">
                        <label>Aplic.:</label>
                    </div>
                    {insumos && insumos.length > 0 ? insumos.map((insumo, index) => (renderInsumo(insumo, index))) : ''}
                    {renderNewInsumo()}
                </div>
            </>
        )

    }

    function handleMaskArea(value) {
        setArea(value);
    }

    function handleMaskLamina(value) {
        setLamina(value);
    }

    function handleMaskVolume(value) {
        setVolume(value);
    }

    function handleMaskMetragem(value) {
        setMetragem(value);
    }
    function handleMaskEspacamento(value) {
        setEspacamento(value);
    }

    function handleMaskData(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        setData(maskedValue);
    }

    function handleMaskInicio(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99:9", "99:99",
        ]);
        setInicio(maskedValue);
    }

    function handleMaskTermino(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99:9", "99:99",
        ]);
        setTermino(maskedValue);
    }

    function handledown(e, ref) {
        if (e.key === "Enter") {
            ref.current.focus();
        }
    }

    function handleLaminaKeyDown(e, ref) {
        if (e.key === "Enter") {
            if (tipoAplicacao.selectItem !== 3) {
                handleSalvarLctos();
            } else {
                ref.current.focus();
            }

        }
    }

    function handleVolumeKeyDown(e) {
        if (e.key === "Enter") {
            if (tipoAplicacao.selectItem === 3) {
                handleSalvarLctos();
            }
        }
    }

    function handleEspacamentoKeyDown(e) {
        if (tipoAplicacao.selectItem === 2) {
            return (
                handledown(e, metragemRef)

            )
        } else if (tipoAplicacao.selectItem === 3) {
            return (
                handledown(e, areaRef)
            )
        } else {
            return (
                handledown(e, laminaRef)
            )
        }

    }

    function renderEspacamento() {
        if (tipoAplicacao.selectItem !== 3) {
            return (
                <div className="column-num">
                    <label>Esp.:</label>
                    <input
                        ref={espacamentoRef}
                        onKeyDown={(e) => handleEspacamentoKeyDown(e)}
                        type="text"
                        id="espacamento"
                        className="form-control edit"
                        value={espacamento}
                        onChange={(e) => handleMaskEspacamento(e.target.value)}
                    />
                </div>
            )
        }
    }

    function renderNextLcto() {
        if (parseInt(tipoAplicacao.selectItem) === 3) {
            return (
                <input
                    ref={metragemRef}
                    onKeyDown={(e) => handledown(e, areaRef)}
                    type="text"
                    id="metragem"
                    className="form-control edit"
                    value={metragem}
                    onChange={(e) => handleMaskMetragem(e.target.value)}
                />
            )
        } else {
            return (
                <input
                    ref={metragemRef}
                    onKeyDown={(e) => handledown(e, laminaRef)}
                    type="text"
                    id="metragem"
                    className="form-control edit"
                    value={metragem}
                    onChange={(e) => handleMaskMetragem(e.target.value)}
                />
            )
        }
    }

    function renderMtMangueira() {
        if (tipoAplicacao.selectItem === 2) {
            return (
                <div className="column-num">
                    <label>Mt. Mang.:</label>
                    {renderNextLcto()}
                </div>
            )
        }
    }

    function onFinalizar() {
        window.location.reload();
    }

    function handleLastReg() {
        if (capa && capa.id && capa.id !== '') {
            api.get(`/dados/capa/ope_capa_id/${capa.id}`)
                .then(function (response) {
                    if (response.data) {
                        setMatricula(response.data.pessoa.matricula);
                        api.get(`/pessoas/matricula/${response.data.pessoa.matricula}`)
                            .then(function (response) {
                                if (response.data) {
                                    setPessoa(response.data);
                                }
                            }).catch(function (error) {
                                alert(error);
                                console.log(error);
                            }).then(function () {
                                // always executed
                            });
                        setInicio(
                            moment(response.data.hr_fim).utc().format('HH:mm')
                        );
                        setCodFazenda(response.data.propriedade.codprop);
                        setCodTalhao(response.data.talhao.cod_talhao);
                        setCodEtapa(response.data.etapa.cod_etapa);
                        setEtapa(response.data.etapa);
                    }
                }).catch(function (error) {
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });
        }


    }

    useEffect(() => {
        if (capa.id) {
            handleLastReg();
            matRef.current.focus();
        } else {
            tipoAplicRef.current.focus();
        }

    }, [capa.id]);

    function handleSalvarCapa(e) {
        if (e.key === "Enter") {
            if (salvando) {
                return;
            }
            setSalvando(true);


            if (!capa.id || capa.id == null) {
                const capat = {
                    dt_irrigacao: data,
                    cod_frota: frota,
                    implemento: imp,
                    num_os: os,
                    ope_tipo_aplicacao_id: tipoAplicacao.selectItem,
                    ope_tipo_irrigacao_id: tipoIrrigacao.selectItem,
                    horimetro_ini: parseFloat(horimIni.replace(',', '.')).toFixed(2),
                    horimetro_fim: parseFloat(horimFim.replace(',', '.')).toFixed(2),
                }
                api.post(`/capa`, capat).then(function (response) {
                    if (response.data) {
                        if (!response.data.erro) {
                            history.push('/novairrigacao/' + response.data.id);
                            window.location.reload();
                        } else {
                            if (response.data.id) {
                                var answer = window.confirm(response.data.erro);
                                if (answer) {
                                    history.push('/novairrigacao/' + response.data.id);
                                    window.location.reload();
                                }
                            } else {
                                alert(response.data.erro);
                                console.log(response.data.erro);
                            }

                        }
                    }
                }).catch(function (error) {
                    alert(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });
            } else {
                const capat = {
                    id: capa.id,
                    dt_irrigacao: data,
                    cod_frota: frota,
                    implemento: imp,
                    num_os: os,
                    ope_tipo_aplicacao_id: tipoAplicacao.selectItem,
                    ope_tipo_irrigacao_id: tipoIrrigacao.selectItem,
                    horimetro_ini: parseFloat(horimIni.replace(',', '.')).toFixed(2),
                    horimetro_fim: parseFloat(horimFim.replace(',', '.')).toFixed(2),
                }

                api.put(`/capa`, capat).then(function (response) {
                    if (response.data) {
                        if (!response.data.erro) {
                            history.push('/novairrigacao/' + capa.id);
                            window.location.reload();
                        } else {
                            alert(response.data.erro);
                            console.log(response.data.erro);
                        }
                    }
                }).catch(function (error) {
                    alert(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });
            }
        }
    }

    function handleSalvarInsumos(insumo) {
        api.post(`/insumos`, insumo).then(function (response) {
            if (response.data) {
                var novoinsumo = Object.assign(insumos);
                novoinsumo.push(response.data);
                setInsumos(novoinsumo);
            }
        }).catch(function (error) {
            // handle error
            // setMessageSalvar('OCORREU UM ERRO AO SALVAR, VERIFIQUE OS DADOS DIGITADOS')
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function handleUpdateInsumo(insumo) {
        api.put(`/insumos`, insumo).then(function (response) {
            if (response.data) {
                setInsumos(response.data);
            }
        }).catch(function (error) {
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function handleSalvarLctos() {
        if (salvando) {
            return;
        }

        if (!capa.id && (capa.id !== '' || capa.id === 0)) {
            return;
        }

        if (!lcto.id && (lcto.id !== '' || lcto.id === 0)) {
            var hr_ini;
            var hr_fim

            if (isValid(parse(`${data} ${inicio}`, 'dd/MM/yyyy HH:mm', new Date()))) {
                hr_ini = format(parse(`${data} ${inicio}`, 'dd/MM/yyyy HH:mm', new Date()), 'HH:mm', { timeZone: 'America/Sao_Paulo' });
            } else {
                alert('HORA INICIO NÃO É UM HORÁRIO VÁLIDO');
                return;
            };

            if (isValid(parse(`${data} ${termino}`, 'dd/MM/yyyy HH:mm', new Date()))) {
                hr_fim = format(parse(`${data} ${termino}`, 'dd/MM/yyyy HH:mm', new Date()), 'HH:mm', { timeZone: 'America/Sao_Paulo' })
            } else {
                alert('HORA FIM NÃO É UM HORÁRIO VÁLIDO');
                return;
            };

            if (!pessoa || !pessoa.id) {
                alert('POR FAVOR MAIS ATENÇÃO AO LANÇAMENTO, ESSA MATRICULA NÃO FOI ENCONTRADA');
                return;
            }

            if (!fazenda || !fazenda.id) {
                alert('POR FAVOR MAIS ATENÇÃO AO LANÇAMENTO, ESSA FAZENDA NÃO FOI ENCONTRADA');
                return;
            }

            if (!talhao || !talhao.id) {
                alert('POR FAVOR MAIS ATENÇÃO AO LANÇAMENTO, ESSE TALHÃO NÃO FOI ENCONTRADO');
                return;
            }

            if (!operacao || !operacao.id) {
                alert('POR FAVOR MAIS ATENÇÃO AO LANÇAMENTO, ESSA OPERAÇÃO NÃO FOI ENCONTRADA');
                return;
            }

            if (!etapa || !etapa.id) {
                alert('POR FAVOR MAIS ATENÇÃO AO LANÇAMENTO, ESSA ETAPA NÃO FOI ENCONTRADA');
                return;
            }

            const lancamento = {
                ope_capa_id: capa.id,
                pessoa_id: pessoa.id,
                hr_ini: hr_ini,
                hr_fim: hr_fim,
                espacamento: espacamento,
                mt_mangueira: metragem,
                lamina: lamina,
                area: area,
                volume: volume,
                propriedade_id: fazenda.id,
                talhoes_id: talhao.id,
                ope_operacoes_id: operacao.id,
                ope_etapas_id: etapa.id,
                dt_lcto: data,
            }

            setSalvando(true);

            api.post(`/dados`, lancamento).then(function (response) {
                if (response.data) {
                    if (response.data.erro) {
                        alert(response.data.erro);
                    } else {
                        setLcto(response.data);
                        setLamina(response.data.lamina);
                        setArea(response.data.area);
                        setVolume(response.data.volume);
                        setQtdAplicada(response.data.qtd_aplicada);
                        if (operacao && operacao.tipo === 1) {
                            const insumosalvar = {
                                ope_dados_id: response.data.id,
                                produtos_id: operacao.produto_id,
                                qtd_aplicada: parseFloat(response.data.qtd_aplicada),
                                qtd_recomendada: parseFloat(response.data.lamina),
                                qtd_produto: parseFloat(response.data.volume),
                                area: parseFloat(response.data.area),
                                ope_operacoes_id: operacao.id,
                                ope_etapas_id: etapa.id,
                            };
                            handleSalvarInsumos(insumosalvar);
                        }
                        if (operacao && operacao.tipo === 2) {
                            window.location.reload();
                        }

                    }
                }
            }).catch(function (error) {
                // handle error
                // setMessageSalvar('OCORREU UM ERRO AO SALVAR, VERIFIQUE OS DADOS DIGITADOS')
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setSalvando(false);
            });
        } else {
            if (isValid(parse(`${data} ${inicio}`, 'dd/MM/yyyy HH:mm', new Date()))) {
                hr_ini = format(parse(`${data} ${inicio}`, 'dd/MM/yyyy HH:mm', new Date()), 'HH:mm', { timeZone: 'America/Sao_Paulo' });
            } else {
                alert('HORA INICIO NÃO É UM HORÁRIO VÁLIDO');
                return;
            };

            if (isValid(parse(`${data} ${termino}`, 'dd/MM/yyyy HH:mm', new Date()))) {
                hr_fim = format(parse(`${data} ${termino}`, 'dd/MM/yyyy HH:mm', new Date()), 'HH:mm', { timeZone: 'America/Sao_Paulo' });
            } else {
                alert('HORA FIM NÃO É UM HORÁRIO VÁLIDO');
                return;
            };

            const lancamento = {
                id: lcto.id,
                ope_capa_id: capa.id,
                pessoa_id: pessoa.id,
                hr_ini: hr_ini,
                hr_fim: hr_fim,
                espacamento: espacamento.toString(),
                mt_mangueira: metragem.toString(),
                lamina: lamina.toString(),
                area: area.toString(),
                volume: volume.toString(),
                propriedade_id: fazenda.id,
                talhoes_id: talhao.id,
                ope_operacoes_id: operacao.id,
                ope_etapas_id: etapa.id,
                dt_lcto: data,
            }

            api.put(`/dados`, lancamento).then(function (response) {
                if (response.data) {
                    if (response.data.erro) {
                        alert(response.data.erro);
                    } else {
                        setLcto(response.data);
                        setLamina(response.data.lamina);
                        setArea(response.data.area);
                        setVolume(response.data.volume);
                        setQtdAplicada(response.data.qtd_aplicada);
                        const insumosalvar = {
                            ope_dados_id: response.data.id,
                            produtos_id: operacao.produto_id,
                            new_produto: response.data.operacao.produto_id,
                            qtd_aplicada: parseFloat(response.data.qtd_aplicada),
                            qtd_recomendada: parseFloat(response.data.lamina),
                            qtd_produto: parseFloat(response.data.volume),
                            area: parseFloat(response.data.area),
                            ope_operacoes_id: operacao.id,
                            ope_etapas_id: etapa.id,
                        };
                        handleUpdateInsumo(insumosalvar);
                        if (operacao && operacao.tipo === 2) {
                            window.location.reload();
                        }
                    }
                }
            }).catch(function (error) {
                // handle error
                // setMessageSalvar('OCORREU UM ERRO AO SALVAR, VERIFIQUE OS DADOS DIGITADOS')
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setSalvando(false);
            });
        }
    }

    function handleBuscaPessoa(e) {

        if (e.key === "Enter") {
            api.get(`/pessoas/matricula/${e.target.value}`)
                .then(function (response) {
                    if (response.data) {
                        if (!response.data.erro) {
                            setPessoa(response.data);
                            handledown(e, operacaoRef);
                        } else {
                            alert(response.data.erro);
                        }
                    }
                }).catch(function (error) {
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });

        }
    }

    function handleSetPessoa(e) {
        // var pessoaedit = Object.assign(pessoa);
        // pessoaedit.matricula = e.target.value;
        // setPessoa(pessoaedit);
        setMatricula(e.target.value);
    }

    function handleBuscaFazenda(e) {

        if (e.key === "Enter") {
            api.get(`/propriedade/cod_prop/${e.target.value}`)
                .then(function (response) {
                    if (response.data) {
                        if (!response.data.erro) {
                            setFazenda(response.data);
                            handledown(e, talhaoRef);
                        } else {
                            alert(response.data.erro);
                        }
                    }
                }).catch(function (error) {
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });

        }
    }

    function handleSetFazenda(e) {
        // var fazendaedit = Object.assign(fazenda);
        // fazendaedit.codprop = e.target.value;
        // setFazenda(fazendaedit);
        setCodFazenda(e.target.value);
    }

    function handleBuscaTalhao(e) {
        if (e.key === "Enter") {

            // apiadi.get(`/importadores/importador?descricao=PARTES`).then(function (response) {
            //     if (response.data) {
            //         setImportador(response.data);
            //         if (response.data.id && (parseInt(response.data.importadores_status[0].status) !== 5)) {
            //             setModalPartesOpen(true);
            //             return;
            //         }

            //     }
            // }).catch(function (error) {
            //     // handle error
            //     console.log(error);
            // }).then(function () {
            //     // always executed
            // });

            if ((!etapa || !etapa.cod_etapa) || (!operacao || !operacao.cod_operacao)) {
                alert('INFORME A ETAPA E OPERAÇÃO PARA CONSULTAR TALHÃO');
                return;
            }

            if (e.target.value === '' || parseInt(e.target.value) <= 0) {
                alert('O TALHÃO DEVE SER SOMENTE NUMERICO')
            } else {

                api.get(`/talhao/cod_prop/${codFazenda}/cod_talhao/${e.target.value}/etapa/${etapa.cod_etapa}/operacao/${operacao.cod_operacao}`)
                    .then(function (response) {
                        if (response.data) {
                            if (!response.data.erro) {
                                setTalhao(response.data);
                                handledown(e, inicioRef);
                            } else {
                                alert(response.data.erro);
                            }
                        }
                    }).catch(function (error) {
                        alert(error);
                        console.log(error);
                    }).then(function () {
                        // always executed
                    });
            }
        }
    }

    function handleSetTalhao(e) {
        setCodTalhao(e.target.value);
    }

    function handleBuscaOperacao(e) {
        if (e.key === "Enter") {
            api.get(`/operacao/cod_operacao/${e.target.value}/tipo_aplicacao/${tipoAplicacao.selectItem}/tipo_irrigacao/${tipoIrrigacao.selectItem}`)
                .then(function (response) {
                    if (response.data) {
                        if (!response.data.erro) {
                            setOperacao(response.data);
                            handledown(e, etapaRef);
                        } else {
                            setOperacao({});
                            alert(response.data.erro);
                        }
                    }
                }).catch(function (error) {
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });
        }
    }

    function handleSetOperacao(e) {
        // var operacaoedit = Object.assign(operacao);
        // operacaoedit.cod_operacao = e.target.value;
        // setOperacao(operacaoedit);
        setCodOperacao(e.target.value);
    }

    function handleBuscaEtapa(e) {
        if (e.key === "Enter") {
            api.get(`/etapa/cod_etapa/${e.target.value}`)
                .then(function (response) {
                    if (response.data) {
                        if (!response.data.erro) {
                            setEtapa(response.data);
                            handledown(e, fazendaRef);
                        } else {
                            alert(response.data.erro);
                        }
                    }
                }).catch(function (error) {
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });

        }
    }

    function handleSetEtapa(e) {
        // var etapaedit = Object.assign(etapa);
        // etapaedit.cod_etapa = e.target.value;
        // setEtapa(etapaedit);
        setCodEtapa(e.target.value);
    }

    function keyDownForm(e) {
        if (e.key === "F3") {
            window.location.reload();
        }
        if (e.key === "F4") {
            handleNovoLancamento();
        }
    }

    function handleNovoLancamento() {
        history.push('/novairrigacao');
        window.location.reload();
    }

    function renderButtonInsumos() {
        if (lcto && lcto.id && lcto.id !== '' && operacao && operacao.tipo && operacao.tipo === 1) {
            return (
                <div className="column-button">
                    <a href="#abrirModal" className="btn btn-primary btn-sm add">Insumos</a>
                </div>
            )
        }
    }

    function onDeletarLcto(e) {
        api.delete(`/dados/id/${lcto.id}/capa/${capa.id}`).then(function (response) {
            if (response.data) {
                window.location.reload();
            }
        }).catch(function (error) {
            alert(error);
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderButtomDeletar() {
        if (lcto && lcto.id && lcto.id !== '') {
            return (
                <div className="column-button">
                    <div className="salvar">
                        <input type="submit" className="btn btn-danger btn-sm add" onClick={(e) => onDeletarLcto(e)} value="Deletar" />
                    </div>
                </div>
            )
        }
    }

    function renderOrdemLcto() {
        if (parseInt(tipoAplicacao.selectItem) === 3) {
            return (
                <>
                    <div className="column-num">
                        <label>Área(ha):</label>
                        <input
                            ref={areaRef}
                            onKeyDown={(e) => handledown(e, laminaRef)}
                            type="text"
                            id="area" className="form-control edit"
                            value={area}
                            onChange={(e) => handleMaskArea(e.target.value)}
                        />
                    </div>
                    < div className="column-num" >
                        <label>Lâmina(mm):</label>
                        <input
                            ref={laminaRef}
                            onKeyDown={(e) => handleLaminaKeyDown(e, volumeRef)}
                            type="text"
                            id="lamina"
                            className="form-control edit"
                            value={lamina}
                            onChange={(e) => handleMaskLamina(e.target.value)}
                        />
                    </div >

                </>
            )
        } else {
            return (
                <>
                    < div className="column-num" >
                        <label>Lâmina(mm):</label>
                        <input
                            ref={laminaRef}
                            onKeyDown={(e) => handleLaminaKeyDown(e, areaRef)}
                            type="text"
                            id="lamina"
                            className="form-control edit"
                            value={lamina}
                            onChange={(e) => handleMaskLamina(e.target.value)}
                        />
                    </div >
                    <div className="column-num">
                        <label>Área(ha):</label>
                        <input
                            ref={areaRef}
                            onKeyDown={(e) => handledown(e, volumeRef)}
                            type="text"
                            id="area" className="form-control edit"
                            value={area}
                            onChange={(e) => handleMaskArea(e.target.value)}
                        />
                    </div></>
            )
        }
    }

    function renderProdutivasParadas() {

        if (operacao && operacao.tipo && operacao.tipo === 1) {
            return (
                <>
                    {renderEspacamento()}
                    {renderMtMangueira()}
                    {renderOrdemLcto()}

                    <div className="column-num">
                        <label>Volume(m³):</label>
                        <input
                            ref={volumeRef}
                            onKeyDown={(e) => handleVolumeKeyDown(e)}
                            type="text"
                            id="volume"
                            className="form-control edit"
                            value={volume}
                            onChange={(e) => handleMaskVolume(e.target.value)}
                        />
                    </div>
                    <div className="column-num">
                        <label>Aplic.:</label>
                        <input
                            ref={qtdAplicRef}
                            // onKeyDown={(e) => handledown(e, espacamentoRef)}
                            type="text"
                            id="volume"
                            className="form-control edit"
                            value={qtdAplicada}
                        // onChange={(e) => handleMaskQtd(e.target.value)}
                        />
                    </div>

                    <div id="abrirModal" className="modald border">
                        <a href="#fechar" className="fechar">x</a>
                        <b>LANÇAMENTO DE INSUMOS</b>
                        <div>{renderInsumos()}</div>
                    </div>
                </>
            )
        }
    }

    function handleTerminoKeyDown(e) {
        if (e.key === 'Enter') {
            var originalValue = unMask(e.target.value);
            if (originalValue.length === 1) {
                originalValue = '0' + originalValue;
            }
            if (originalValue.length === 2) {
                originalValue = originalValue + '00';
            }
            if (originalValue.length === 3) {
                originalValue = originalValue + '0';
            }

            handleMaskTermino(originalValue);

            if (operacao && operacao.tipo === 2) {
                handleSalvarLctos();
            } else {
                if (tipoAplicacao.selectItem === 1 || tipoAplicacao.selectItem === 2) {
                    handledown(e, espacamentoRef)
                } else {
                    handledown(e, areaRef)
                }
            }

        }

    }

    function renderTotalHorasEArea() {
        var totalhoras = 0;
        var totalarea = 0;
        var horasprod = 0;
        var horasparadas = 0;

        if (dados) {
            dados.forEach(dado => {
                const inicio = new Date(dado.hr_ini);
                const fim = new Date(dado.hr_fim);
                totalhoras = totalhoras + (Math.abs(inicio - fim) / 1000);
                totalarea = totalarea + dado.area;
                if (dado.operacao && dado.operacao.tipo === 1) {
                    horasprod = horasprod + (Math.abs(inicio - fim) / 1000);
                } else {
                    horasparadas = horasparadas + (Math.abs(inicio - fim) / 1000);
                }
            });
        }

        var duration = intervalToDuration({ start: 0, end: totalhoras * 1000 });

        const formatedtotal = (duration.days > 0 ? duration.hours + 24 : (duration.hours >= 10 ? duration.hours : `0${duration.hours}`)) + ':' + (duration.minutes >= 10 ? duration.minutes : `0${duration.minutes}`)

        duration = intervalToDuration({ start: 0, end: horasprod * 1000 });

        const formatedprod = (duration.days > 0 ? duration.hours + 24 : (duration.hours >= 10 ? duration.hours : `0${duration.hours}`)) + ':' + (duration.minutes >= 10 ? duration.minutes : `0${duration.minutes}`)

        duration = intervalToDuration({ start: 0, end: horasparadas * 1000 });

        const formatedparada = (duration.days > 0 ? duration.hours + 24 : (duration.hours >= 10 ? duration.hours : `0${duration.hours}`)) + ':' + (duration.minutes >= 10 ? duration.minutes : `0${duration.minutes}`)

        return (
            <>
                <div className="total">
                    <b className="totais">HORAS LANÇADAS: {formatedtotal}</b>
                    <b className="totais">HORAS PRODUTIVAS: {formatedprod}</b>
                    <b className="totais">HORAS PARADAS {formatedparada}</b>
                    <b className="totais">HORAS HORIMETRO: {capa.horimetro_fim - capa.horimetro_ini}</b>
                    <b className="totais">ÁREA TOTAL: {totalarea.toFixed(2)} ha</b>
                </div>
            </>
        )
    }
    function renderButtomFinfalizar() {
        if (lcto && lcto.id && lcto.id !== '') {
            return (
                <div className="column-button">

                    <div className="salvar">
                        <input type="submit" className="btn btn-success btn-sm add" onClick={onFinalizar} value="Finalizar (F3)" />
                    </div>
                </div>
            )
        }
    }

    function handledownHrIni(e) {
        if (e.key === 'Enter') {
            var originalValue = unMask(e.target.value);
            if (originalValue.length === 1) {
                originalValue = '0' + originalValue;
            }
            if (originalValue.length === 2) {
                originalValue = originalValue + '00';
            }
            if (originalValue.length === 3) {
                originalValue = originalValue + '0';
            }

            handleMaskInicio(originalValue);
            handledown(e, terminoRef)
        }

    }

    // function renderspin() {
    //     return (
    //         <div className='spinner'></div>
    //     )
    // }

    // function renderstatus(importacao) {

    //     if (!importacao.id) {
    //         return;
    //     }
    //     if (importacao.importadores_status[0].status === 0) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Aguardando
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 6) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Excluindo
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 1) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Erro
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 2) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Baixando
    //                 </div>
    //                 <div className="context">
    //                     Servidor: {importacao.importadores_status[0].servidor}
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 3) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Inserindo
    //                 </div>
    //                 <div className="context">
    //                     Servidor: {importacao.importadores_status[0].servidor}
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 4) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Sincronizando
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 5) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Concluido
    //                 </div>
    //             </div>
    //         )
    //     }
    // }

    // function fecharModalParte() {
    //     setModalPartesOpen(false);
    // }


    // function renderModalPartes() {
    //     return (
    //         <div className={(modalPartesOpen ? "modal-partes container-lg" : "modal-fechado")}>
    //             <span className="fechar-modal-previsoes" onClick={() => fecharModalParte()}>x</span>
    //             <div>
    //                 ALGUEM ESTÁ ATUALIZANDO AS PARTES, POR GENTILEZA AGUARDE ATÉ QUE O PROCESSO TERMINE
    //             </div>
    //             <div className="itens-modal-insumos">
    //                 <hr></hr>
    //                 <div className="form modal-insumos">
    //                     <div className="card-import">
    //                         <div className="containder-title Content">
    //                             {importador.descricao}
    //                         </div>
    //                         {renderstatus(importador)}
    //                         <div className="horas">
    //                             Atualizado em: {(importador && importador.importadores_status ? moment(importador.importadores_status[0].updatedAt).utc().format('DD/MM/YYYY HH:mm:ss') : '')}
    //                         </div>
    //                     </div>

    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }

    function handleDeleteLcto() {
        if (capa && capa.id && capa.id !== '') {
            Swal.fire({
                title: "TEM CERTEZA QUE DESEJA APAGAR O LANÇAMENTO? APÓS APAGAR, SERÃO APAGADOS TODOS OS SEUS LANÇAMENTOS E LANÇAMENTOS DE INSUMOS!",
                showDenyButton: true,
                showConfirmButton: true,
                denyButtonText: "CANCELAR",
                confirmButtonText: "CONFIRMAR",
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    console.log('entra aqui porra')
                    api.delete(`/capa/id/${capa.id}`).then(function (response) {
                        if (response.data) {
                            Swal.fire('APAGADO COM SUCESSO!')
                            history.push('/novairrigacao');
                            window.location.reload();
                        }
                    }).catch(function (error) {
                        // handle error
                        console.log(error);
                    }).then(function () {
                        // always executed
                    });

                } else if (result.isDenied) {

                }
            })

        }
    }

    function renderBtnApagar() {
        if (capa && capa.id && capa.id !== '') {
            return (
                <div className="rigth">
                    <input type="submit" value="APAGAR LANÇAMENTO" className="btn btn-danger btn-sm add" onClick={() => handleDeleteLcto()} />
                </div>
            )
        }
    }

    return (

        <div className="container-lg ">
            <Header title="LANÇAMENTO DE IRRIGAÇÃO" />
            {/* {renderModalPartes()} */}
            <div className="lcto controle-irrigacao" onKeyDown={(e) => keyDownForm(e)} tabIndex={0}>
                <div className='bnttopo'>
                    <div className="left">
                        <input type="submit" value="Novo lançamento (F4)" className="btn btn-success btn-sm add" onClick={() => handleNovoLancamento()} />
                    </div>
                    {renderBtnApagar()}
                </div>
                <div className="capa borda">
                    <h4>CAPA: {(capa && capa.id && capa.id !== null && capa.id !== '' ? capa.id : '')}</h4>
                    <hr></hr>
                    <div className="form">
                        <div className="column-tipo">
                            <label>Tipo Aplicação:</label>
                            <select
                                className="col-md-12 combobox  edit form-control"
                                value={tipoAplicacao.selectItem}
                                onChange={(e) => handleSelecTipoAplicacao(e.target.value)}
                                ref={tipoAplicRef}
                                onKeyDown={(e) => handledown(e, tipoIrrigRef)}
                            >
                                {tipoAplicacao.items.map((item, index) => (
                                    <option key={index} value={item.id}>{item.text}</option>
                                ))}
                            </select>
                        </div>
                        <div className="column-agua">
                            <label>Tipo Irrig.:</label>
                            <select
                                className="col-md-11 combobox edit form-control"
                                value={tipoIrrigacao.selectItem} onChange={(e) => handleSelecTipoIrrigacao(e.target.value)}
                                ref={tipoIrrigRef}
                                onKeyDown={(e) => handledown(e, dataRef)}
                            >
                                {tipoIrrigacao.items.map((item, index) => (
                                    <option key={index} value={item.id}>{item.text}</option>
                                ))}
                            </select>
                        </div>
                        <div className="column-data">
                            <label>Data:</label>
                            <input
                                type="text"
                                id="data"
                                ref={dataRef}
                                value={data}
                                className="form-control edit"
                                onKeyDown={(e) => handledown(e, osRef)}
                                onChange={(e) => handleMaskData(e.target.value)}
                            />
                        </div>
                        <div className="column-num">
                            <label>O.S.:</label>
                            <input
                                id="os"
                                value={os}
                                onKeyDown={(e) => handledown(e, frotaRef)}
                                ref={osRef}
                                className="form-control edit" type="text"
                                onChange={(e) => setOs(e.target.value)}
                            />
                        </div>
                        <div className="column-num">
                            <label>Frota:</label>
                            <input
                                id="frota"
                                value={frota}
                                ref={frotaRef}
                                onKeyDown={(e) => handledown(e, impRef)}
                                className="form-control edit"
                                type="text"
                                onChange={(e) => setFrota(e.target.value)}
                            />
                        </div>
                        <div className="column-num">
                            <label>Imp.:</label>
                            <input
                                id="implemento"
                                onChange={(e) => setImp(e.target.value)}
                                ref={impRef}
                                onKeyDown={(e) => handledown(e, horimIniRef)}
                                className="form-control edit"
                                type="text"
                                value={imp}
                            />
                        </div>
                        <div className="column-num">
                            <label>Horim. Ini.:</label>
                            <input
                                id="implemento"
                                onChange={(e) => setHorimIni(e.target.value)}
                                ref={horimIniRef}
                                onKeyDown={(e) => handledown(e, horimFimRef)}
                                className="form-control edit"
                                type="text"
                                value={horimIni}
                            />
                        </div>
                        <div className="column-num">
                            <label>Horim. Fim.:</label>
                            <input
                                id="implemento"
                                onChange={(e) => setHorimFim(e.target.value)}
                                ref={horimFimRef}
                                onKeyDown={(e) => handleSalvarCapa(e)}
                                className="form-control edit"
                                type="text"
                                value={horimFim}
                            />
                        </div>
                    </div>
                </div>
                <div className="items borda">
                    <b>LANÇAMENTOS:</b>
                    <hr></hr>

                    <div className="form">
                        <div className="column-ope">
                            <b>AREA TOTAL: {(talhao && talhao.area_plantada ? talhao.area_plantada : 'SEM PARTES PARA OS PARAMETROS')}</b>
                        </div>
                        <div className="column-ope">
                            <b>ÁREA IRRIGADA: {(talhao && talhao.area_irrigada ? talhao.area_irrigada : '0')}</b>
                        </div>
                    </div>
                    <div className="form">
                        <div className="column-ope">
                            <div className="column-num">
                                <label>Matricula:</label>
                                <input
                                    ref={matRef}
                                    onKeyDown={(e) => handleBuscaPessoa(e)}
                                    id="pessoa1"
                                    className="form-control edit"
                                    type="text"
                                    value={matricula}
                                    onChange={(e) => handleSetPessoa(e)}
                                />
                            </div>
                            <div className="column-button">
                                <button type="submit" className="btn btn-info btn-sm search" onClick={onclick}><span className="lnr lnr-magnifier"></span></button>
                            </div>
                            <div className="column-name">
                                <p className="descprod">{pessoa.nome}</p>
                            </div>
                        </div>
                        <div className="column-ope">
                            <div className="column-num">
                                <label>Operação:</label>
                                <input
                                    ref={operacaoRef}
                                    onKeyDown={(e) => handleBuscaOperacao(e)}
                                    className="form-control edit"
                                    type="text"
                                    value={(codOperacao)}
                                    onChange={(e) => handleSetOperacao(e)}
                                />
                            </div>
                            <div className="column-button">
                                <button type="submit" className="btn btn-info btn-sm search" onClick={onclick}><span className="lnr lnr-magnifier"></span></button>
                            </div>
                            <div className="column-descricao">
                                <p className="descprod">{operacao ? operacao.descricao : ''}</p>
                            </div>
                        </div>
                        <div className="column-ope">
                            <div className="column-num">
                                <label>Etapa:</label>
                                <input
                                    // id={`etapa${insumo.id}`}
                                    ref={etapaRef}
                                    onKeyDown={(e) => handleBuscaEtapa(e)}
                                    value={codEtapa}
                                    className="form-control edit"
                                    type="text"
                                    onChange={(e) => handleSetEtapa(e)}
                                />
                            </div>
                            <div className="column-button">
                                <button type="submit" className="btn btn-info btn-sm search" onClick={onclick}><span className="lnr lnr-magnifier"></span></button>
                            </div>
                            <div className="column-descricao">
                                <p className="descprod">{etapa.descricao}</p>
                            </div>
                        </div>
                    </div>
                    <div className="form">
                        <div className="column-num prim">
                            <label>Faz.:</label>
                            <input
                                id="fazenda"
                                ref={fazendaRef}
                                onKeyDown={(e) => handleBuscaFazenda(e)}
                                value={codFazenda}
                                className="form-control edit"
                                type="text"
                                onChange={(e) => handleSetFazenda(e)}
                            />
                        </div>
                        <div className="column-num">
                            <label>Talhão:</label>
                            <input
                                id="talhao"
                                ref={talhaoRef}
                                onKeyDown={(e) => handleBuscaTalhao(e)}
                                value={codTalhao}
                                className="form-control edit"
                                type="text"
                                onChange={(e) => handleSetTalhao(e)}
                            />
                        </div>
                        <div className="column-horas">
                            <label>Inicio:</label>
                            <input
                                ref={inicioRef}
                                onKeyDown={(e) => handledownHrIni(e)}
                                value={inicio}
                                id="hrinicio"
                                className="form-control edit"
                                type="text"
                                onChange={(e) => handleMaskInicio(e.target.value)}
                            />
                        </div>
                        <div className="column-horas">
                            <label>Termino:</label>
                            <input
                                ref={terminoRef}
                                onKeyDown={(e) => handleTerminoKeyDown(e)}
                                value={termino}
                                id="hrfim"
                                className="form-control edit"
                                type="text"
                                onChange={(e) => handleMaskTermino(e.target.value)}
                            />
                        </div>
                        {renderProdutivasParadas()}
                        <div className="botoes">
                            {renderButtomDeletar()}
                            {renderButtomFinfalizar()}
                            {renderButtonInsumos()}
                        </div>
                    </div>
                </div>
                <div className="content border marged">
                    <table className="table table-borderless table-sm lctos">
                        <thead>
                            <tr>
                                <th scope="col">Mat.</th>
                                <th scope="col">Nome</th>
                                <th scope="col">Ope.</th>
                                <th scope="col">Descrição</th>
                                <th scope="col">Eta.</th>
                                <th scope="col">Descrição</th>
                                <th scope="col">Cod. Faz.</th>
                                <th scope="col">Fazenda</th>
                                <th scope="col">Tal.</th>
                                <th scope="col">Inicio</th>
                                <th scope="col">Termino</th>
                                <th scope="col">Esp.</th>
                                <th scope="col">MT.</th>
                                <th scope="col">Lamina</th>
                                <th scope="col">Área</th>
                                <th scope="col">Volume</th>
                                <th scope="col">Aplic.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (dados ? dados.map(lcto => {
                                    return (
                                        rowLctos(lcto)
                                    )
                                }) : '<tr></tr>')
                            }
                        </tbody>
                    </table>
                </div>
                {renderTotalHorasEArea()}
            </div>
        </div>
    )
}